// What a strip mark stands for on the rows below the strips, for the pointer
// the plane draws toward them and the scroll a click on the mark makes.
//
// A graph mark stands for its claims' comment pins, a notes mark for the reader
// chat's note pins, a finding mark for the cells its findings cite, a join mark
// for its cell pins. The other strips mark turns, which have no row to point
// at.

// How many cells one mark's guide considers.
export const STRIP_GUIDE_CAP = 48;

// The strip mark a plane hit is, for the strips whose marks stand for cells.
export function stripMarkOf(hit) {
    if (hit?.type === "jspan") return { strip: "joins", turn: hit.turn, through: hit.through ?? hit.turn };
    if (hit?.type === "scanmark" && (hit.strip === "graph" || hit.strip === "notes" || hit.strip === "findings" || hit.strip === "reports")) {
        return { strip: hit.strip, turn: hit.turn, through: hit.through ?? hit.turn };
    }
    return null;
}

/**
 * The cells a mark stands for, [{ laneId, turn }], from what the view already
 * holds: the graph's comment-pin anchors and its claims (by id), the reader
 * chat's note anchors, the findings report's incidents, and the join cell
 * pins. A mark spans `turn`..`through` when it folds several turns.
 */
export function stripMarkTargets(mark, { badgeAnchors = [], claimById = null, noteAnchors = [], incidents = [], joinPins = [] } = {}) {
    if (!mark) return [];
    const inRange = (t) => t >= mark.turn && t <= mark.through;
    const out = [];
    if (mark.strip === "graph") {
        // A pin with no lane stands on the strip itself: the mark is its own pin.
        for (const b of badgeAnchors) {
            if (b.lane == null) continue;
            if (b.claims.some((id) => (claimById?.get(id)?.turns || []).some(inRange))) out.push({ laneId: b.lane, turn: b.turn });
        }
    } else if (mark.strip === "notes") {
        // A note on the turn stands on the strip itself, like a graph pin.
        for (const b of noteAnchors) {
            if (b.lane != null && inRange(b.turn)) out.push({ laneId: b.lane, turn: b.turn });
        }
    } else if (mark.strip === "findings" || mark.strip === "reports") {
        // An incident cites turns 1-based; its cells at the marked turns come
        // first, and all of them when none is there.
        for (const inc of incidents || []) {
            if (inc.uncited || !(inc.turns || []).some((t) => inRange(t - 1))) continue;
            const cells = inc.cells || [];
            const here = cells.filter((c) => inRange(c.turn));
            for (const c of here.length ? here : cells) out.push({ laneId: c.lane, turn: c.turn });
        }
    } else if (mark.strip === "joins") {
        for (const p of joinPins || []) {
            if ((p.through ?? p.turn) >= mark.turn && p.turn <= mark.through) out.push({ laneId: p.lane, turn: p.turn });
        }
    }
    return out.slice(0, STRIP_GUIDE_CAP);
}
